import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  constructor() {}
  private URL_HOST = {
    PROD: 'https://api.pos-insights.com',
    STAGE: 'https://api.pos-insights.com',
  };

  private messageSource = new BehaviorSubject('default');
  currentMessage = this.messageSource.asObservable();

  private dateMessageSource = new BehaviorSubject({});
  dateMessage = this.dateMessageSource.asObservable();

  private graphDurationMessageSource = new BehaviorSubject({
    source: null,
    type: null,
  });
  graphDurationMessage = this.graphDurationMessageSource.asObservable();

  updateGraphDuration(type: string, source: string) {
    this.graphDurationMessageSource.next({ type: type, source: source });
  }

  changeMessage(message: any) {
    this.messageSource.next(message);
  }

  updateDate(message: object) {
    this.dateMessageSource.next(message);
  }

  getHostUrl(platform) {
    let url = this.URL_HOST[platform];
    if (url) {
      return url;
    } else {
      return null;
    }
  }
}
